<template>
  <div>
        <v-icon x-small v-if="item.task_status == true"
                @click="onCopyCellToClipboard(item, item_batch_size.batch_size)">mdi-clipboard-multiple
        </v-icon>
        <v-list-item v-for="mpn in item.values_for_batch_size[item_batch_size.batch_size]" :key="mpn.id" class="mx-0">
          <v-list-item-content>
            <v-list-item-title class="text-caption">
              <router-link :to="{name:'BrandComponentItem', params: { brandComponentId: mpn.brand_component_id}}"
                           target="_blank">
                {{ mpn.mpn_name }}
              </router-link>
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption" v-for="pn in mpn.pn_list" :key="pn.id">
              {{ pn.brief_name }}
              <a :href="pn.source" target="target"> {{ pn.part_number }} </a>
              {{ getPrice(pn) }} {{ getPurchasePrice(pn) }} MOQ{{ pn.format_moq }} VE{{ pn.format_multiple }}
              <span :class="getBackgroundColor(pn, item_batch_size.batch_size * item.qty)">
                {{ pn.format_stock }}
              </span>
              <span v-if="pn.ship_date !== 'None'" class="lead_time">
                ({{pn.ship_date | moment("DD.MM.YY")}})
              </span>
            </v-list-item-subtitle>
<!--            <span class="mt-3" v-if="fullView"></span>-->
<!--            <v-list-item-subtitle class="text-caption" v-for="(pn, index) in mpn.pn_list" :key="pn.id"-->
<!--                                  v-if="!isShowPN(item, pn, item_batch_size.batch_size) && fullView">-->
<!--              {{ pn.brief_name }}-->
<!--              <a :href="pn.source" target="target"> {{ pn.part_number }} </a>-->
<!--              <span v-if="pn.price > 0"> {{ pn.price }}€, </span>-->
<!--               {{ getPurchasePrice(pn) }} MOQ{{ pn.format_moq }} VE{{ pn.format_multiple }}-->
<!--              <span :class="getBackgroundColor(pn, item_batch_size.batch_size * item.qty)">-->
<!--                {{pn.format_stock}}</span>-->
<!--              <span v-if="pn.ship_date != 'None'" class="lead_time">-->
<!--                ({{pn.ship_date | moment("DD.MM.YY")}})-->
<!--              </span>-->
<!--            </v-list-item-subtitle>-->
          </v-list-item-content>
        </v-list-item>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import Sortable from 'sortablejs'
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import MPNResearchDetailDialog from "@/components/MPNResearch/MPNResearchDetailDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress";

export default {
  name: 'MPNResearchDetailResult',
  props: ['item', 'item_batch_size'],

  components: {
  },

  computed: {
  },

  methods: {

    getPurchasePrice(pn) {
      if (pn.price != pn.purchase_price && pn.purchase_price != -1 && pn.purchase_price != 0 && pn.purchase_price !== null)
        return pn.purchase_price + '€ buying ' + pn.purchase_amount + ' cnt,'
      return ''
    },

    getPrice(pn) {
      if (pn.price >= 0)
        return pn.price + '€, '
      return ''
    },

    getBackgroundColor(pn, needAmount) {
      if (pn.stock < needAmount)
        return 'stock-low'
      else
        return ''
    },
    onCopyCellToClipboard(item, batch_size) {
      let outerText = '"'
      if (item.values_for_batch_size[batch_size] == null) {
        navigator.clipboard.writeText(null)
        return
      }
      for (const mpn of item.values_for_batch_size[batch_size]) {
        let outerPN = ''
        for (const pn of mpn.pn_list) {
          if (this.isShowPN(item, pn, batch_size)) {
            let pnLine = pn.brief_name + ' ' + pn.part_number + ' ' +
                pn.price + '€ ' + 'MOQ' + pn.format_moq + ' VE' + pn.format_multiple + ' ' +
                pn.format_stock + '\n'
            outerPN += pnLine
          }
        }
        if (this.fullView) {
          outerPN += '\n'
          for (const pn of mpn.pn_list) {
            if (!this.isShowPN(item, pn, batch_size)) {
              let pnLine = pn.brief_name + ' ' + pn.part_number + ' ' +
                  pn.price + '€ ' + 'MOQ' + pn.format_moq + ' VE' + pn.format_multiple + ' ' +
                  pn.format_stock + '\n'
              outerPN += pnLine
            }
          }
        }
        if (outerPN != '')
          outerText += mpn.mpn_name + '\n' + outerPN + '\n'
      }
      outerText += '"'
      navigator.clipboard.writeText(outerText)
    },
    isShowMPN(item, mpn, batch_size) {
      for (let pn of mpn.pn_list)
        if (this.selected_view === 'all' || this.isShowPN(item, pn, batch_size))
          return true
      return false
    },
    isShowPN(item, pn, batch_size) {
      return pn.stock >= (item.qty * batch_size) && pn.price > 0
    },
  },

  // async mounted() {
    // console.log(this.item, this.item_batch_size)
  // },

  created() {
  },
  destroyed() {
  },

  data() {
    return {
      fullView: true,
    }
  }
}
</script>

<style scoped lang="scss">
.stock-low {
  //background-color: #FFEBEE;
  color: red;
}
.lead_time {
  color: forestgreen;
}
</style>
